import { styled } from '@mui/system';

export const Container = styled('div')`
  display: flex;
  justify-content: center; /* Align horizontally */
  align-items: center;     /* Align vertically */
  height: 30vh;   
`;
